'use client'

import S from './FansHeroImageLayers.module.scss'

type FansHeroImageLayersProps = {
  omitGrain?: boolean
}

const FansHeroImageLayers = ({ omitGrain }: FansHeroImageLayersProps) => {
  return (
    <>
      <div className={S.darken} aria-hidden />
      {!omitGrain && <div className={S.grainNoise} aria-hidden />}
      <div className={S.bottomBlend} aria-hidden />
    </>
  )
}

export default FansHeroImageLayers
